// @flow
const PREFIX = 'hive/user/';

export const ANALYTICS_SHARING_TOGGLED = `${PREFIX}ANALYTICS_SHARING_TOGGLED`;
export const DEFAULT_LOCALE = 'en-GB';
export const PIN_SET = 'PIN_SET';
export const SET_PIN = 'SET_PIN';
export const SETTING_PIN = 'SETTING_PIN';
export const RESET_PIN_ERROR = 'RESET_PIN_ERROR';
export const TOGGLE_ANALYTICS_SHARING_ALLOWED = `${PREFIX}TOGGLE_ANALYTICS_SHARING_ALLOWED`;



// WEBPACK FOOTER //
// ./src/core/state/user/constants.js